import i18next from "i18next";
import * as React from "react";
import type { ToastContentProps } from "react-toastify";
import { toast } from "react-toastify";

import { Close } from "@/components/icons/close";
import { Copy } from "@/components/icons/copy";

import { copyTextToClipboard } from "./copy-text-to-clipboard";
import { showToast } from "./toast";

const VIDEO_SHARE_TOAST_CLASS = "Toastify__toast--video-share-copied";

function VideoShareCopiedToastBody(props: ToastContentProps) {
  const { closeToast } = props;
  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      <Copy className="size-4 shrink-0 text-[#B6E8C0]" aria-hidden />
      <p className="min-w-0 flex-1 text-left text-sm font-normal leading-snug text-[#B6E8C0]">
        {i18next.t("content-hub.video-url-copied-to-clipboard")}
      </p>
      <button
        type="button"
        className="flex shrink-0 items-center justify-center rounded p-1 text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        aria-label={i18next.t("content-hub.close-toast")}
        onClick={() => closeToast?.()}
      >
        <Close className="size-5 text-white" aria-hidden />
      </button>
    </div>
  );
}

export function showVideoShareUrlCopiedToast() {
  toast(
    (props: ToastContentProps) => <VideoShareCopiedToastBody {...props} />,
    {
      className: VIDEO_SHARE_TOAST_CLASS,
      bodyClassName: "Toastify__toast-body--video-share-copied",
      closeButton: false,
      autoClose: 4000,
    }
  );
}

export async function copyVideoSharePageUrlAndShowToast(url: string) {
  const copied = await copyTextToClipboard(url);
  if (copied) {
    showVideoShareUrlCopiedToast();
    return;
  }
  showToast("content-hub.video-url-copy-failed", "error");
}
